import { render, staticRenderFns } from "./SalesCrmCompanies.vue?vue&type=template&id=5618ced8&scoped=true&"
import script from "./SalesCrmCompanies.vue?vue&type=script&lang=js&"
export * from "./SalesCrmCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618ced8",
  null
  
)

export default component.exports